import { getKeys } from './getKeys'

export const addResidentModalTranslations = {
  ADD_A_NEW: 'Add a new',
  NEXT: 'Next',
  ADD: 'Add',
  REQUIRED_FIELDS_MARKED_WITH: 'Required fields are marked with',
  PLEASE_SELECT_A_STATUS: 'Please select a status',
  STATUS_ACTIVE: 'Active',
  STATUS_ACTIVE_DESCRIPTION:
    'Create a profile for a service user. Note: this will impact your bill.',
  STATUS_INITIAL_ASSESSMENT: 'Initial Assessment',
  STATUS_INITIAL_ASSESSMENT_DESCRIPTION:
    'Create a profile for a potential service user to assess their care needs.',
  STATUS_DUMMY_PROFILE: 'Dummy Profile',
  STATUS_DUMMY_PROFILE_DESCRIPTION:
    'Create a fake profile to explore Log my Care without affecting your bill. ',
  NEED_HELP: 'Need help?',
  LEARN_ABOUT_INITIAL_ASSESSMENTS: 'Learn about Initial Assessments',
  NAME: 'Name',
  FIRST_NAME: 'First name',
  FIRST_NAME_IS_REQUIRED: 'First name is required',
  LAST_NAME: 'Last name',
  LAST_NAME_IS_REQUIRED: 'Last name is required',
  DUPLICATE_NAME_WARNING:
    'An individual with this name may already exist. Check before adding or use a preferred name',
  PREFERRED_NAME_OPTIONAL: 'Preferred name (optional)',
  GENDER: 'Gender',
  GENDER_IS_REQUIRED: 'Gender is required',
  MALE: 'Male',
  FEMALE: 'Female',
  DATE_OF_BIRTH: 'Date of Birth',
  DATE_OF_BIRTH_IS_REQUIRED: 'Date of birth is required'
}

export const addResidentModalConstants = getKeys(addResidentModalTranslations)
